import { render, staticRenderFns } from "./TukGuides.vue?vue&type=template&id=58a6d4f8&scoped=true"
import script from "./TukGuides.vue?vue&type=script&lang=js"
export * from "./TukGuides.vue?vue&type=script&lang=js"
import style0 from "./TukGuides.vue?vue&type=style&index=0&id=58a6d4f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a6d4f8",
  null
  
)

export default component.exports